export default "__VITE_PUBLIC_ASSET__cf63ff70__"